export default __webpack_public_path__ + "logo2902736.png";